import EventAndStatusHistory from "./EventAndStatusHistory";
import {
	getEventHistoryListByInvoiceNumber,
	getEventHistoryListBySku,
	getEventHistoryListByTransferSourceId,
} from "../../util/historyStorageHelper";
import { EventHistoryListItemProps, ReceiveHistoryProps } from "./types";

export const ReceiveHistory = ({
	statusHistoryList,
	invoiceNumber,
	transferSourceId,
	sku,
	arrivals,
}: ReceiveHistoryProps) => {
	let eventHistoryList: Array<EventHistoryListItemProps> = [];
	if (sku) {
		eventHistoryList = getEventHistoryListBySku(sku) as EventHistoryListItemProps[];
	} else if (invoiceNumber) {
		eventHistoryList = getEventHistoryListByInvoiceNumber(invoiceNumber) as EventHistoryListItemProps[];
	} else if (transferSourceId) {
		eventHistoryList = getEventHistoryListByTransferSourceId(transferSourceId) as EventHistoryListItemProps[];
	}

	return (
		<EventAndStatusHistory
			eventHistoryList={eventHistoryList}
			statusHistoryList={statusHistoryList}
			arrivals={arrivals}
		/>
	);
};
